/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";
import {environment} from "../../../../environments/environment";

/**
 * todo
 */
@Component({
	selector: "aigia-patter-tab",
	templateUrl: "./patter-tab.component.html",
	styleUrls: ["../floating/floating.component.css", "./patter-tab.component.css"],
})
export class PatterTabComponent extends FloatingComponent {

	@Input() public locked: boolean;
	@Input() public endpoint: string;
	@Input() public patters: any[];
	@Input() public style: any;
	@Input() public size: number[];

	@Input() public camera: number[] = [0];

	@Output() public progrssChange = new EventEmitter<boolean>();

	// public transformImages: any[][];

	public title: string = "Image";

	/**
	 * @returns string
	 */
	public filenameToSrc(phase: any): string {
		// TODO: GCP phase.filename
		const gcp = environment.gcp;
		return gcp.storage_service + "/" + gcp.bucket_name + "/" + phase.filename;
		// 	return  "https://storage.googleapis.com/aigia_image/" + phase.filename;
		// 	return this.endpoint + "/files/getid/" + phase._id;
	}

	/**
	 * @returns string
	 */
	public phaseToName(phase: any): string {
		let result: string = "";
		switch (phase.description) {
			case "address":
				result = "AD";
				break;
			case "backswing":
				result = "HB";
				break;
			case "top":
				result = "TP";
				break;
			case "halfdown":
				result = "HD";
				break;
			case "impact":
				result = "IM";
				break;
			case "follow":
				result = "HF";
				break;
			case "finish":
				result = "FN";
				break;
			default:
				break;
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "size":
					if (this.visible) {
						const width = this.size[0];
						const height = this.size[1];
						this.style = {width: width + "px", height: height + "px"};
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}
